/**
 * Electrolyte funnel — scoped to #feelawsm-electrolyte-funnel (Shopify-safe).
 * Add-to-cart mirrors assets/product-form.js (sections in POST, XHR for selling plans, renderContents + open).
 */
(function () {
    "use strict";

    var ROOT_ID = "feelawsm-electrolyte-funnel";
    var root = document.getElementById(ROOT_ID);
    if (!root) {
        return;
    }

    var funnelCfg = {};
    var cfgEl = document.getElementById("FeelawsmElectrolyteFunnelConfig");
    if (cfgEl && cfgEl.textContent) {
        try {
            funnelCfg = JSON.parse(cfgEl.textContent);
        } catch (e) {
            funnelCfg = {};
        }
    }
    var addingLabel =
        funnelCfg && typeof funnelCfg.addingLabel === "string" && funnelCfg.addingLabel
            ? funnelCfg.addingLabel
            : "Adding…";

    var observerOptions = {
        threshold: 0.12,
        rootMargin: "0px 0px -60px 0px",
    };

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("visible");
            }
        });
    }, observerOptions);

    root.querySelectorAll(".fade-in").forEach(function (el) {
        observer.observe(el);
    });

    var lastScroll = window.pageYOffset;
    var stickyCart = root.querySelector(".sticky-cart");
    /* Keep .sticky-cart inside #feelawsm-electrolyte-funnel so funnel-scoped .btn rules and CSS variables apply. */

    function setStickyPadding(show) {
        root.classList.toggle("funnel--has-sticky", !!show);
    }

    function onScroll() {
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (stickyCart) {
            var doc = document.documentElement;
            var threshold = doc.scrollHeight * 0.28;
            if (currentScroll > threshold) {
                stickyCart.classList.add("visible");
                setStickyPadding(true);
            } else {
                stickyCart.classList.remove("visible");
                setStickyPadding(false);
            }
        }

        lastScroll = currentScroll;
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            var id = anchor.getAttribute("href");
            if (!id || id === "#") {
                return;
            }
            var target = document.querySelector(id);
            if (target && root.contains(target)) {
                e.preventDefault();
                target.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        });
    });

    root.querySelectorAll(".faq-question").forEach(function (question) {
        question.addEventListener("click", function () {
            var item = question.closest(".faq-item");
            if (!item) {
                return;
            }
            var wasActive = item.classList.contains("active");
            root.querySelectorAll(".faq-item").forEach(function (faqItem) {
                faqItem.classList.remove("active");
            });
            if (!wasActive) {
                item.classList.add("active");
            }
        });
    });

    function getCartUi() {
        return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    function getCartAddUrl() {
        var cartAddPath =
            typeof routes !== "undefined" && routes.cart_add_url
                ? String(routes.cart_add_url)
                : "/cart/add";
        if (cartAddPath.startsWith("/") && cartAddPath.indexOf("cart") !== -1) {
            return cartAddPath.replace(/\/cart\/add\/?$/, "/cart/add.js");
        }
        return "/cart/add.js";
    }

    function parseQuantity(btn) {
        var q = parseInt(btn.getAttribute("data-quantity"), 10);
        if (!Number.isNaN(q) && q > 0) {
            return q;
        }
        return 1;
    }

    function fetchSectionHtmlForCart(cart, data, doRender) {
        if (data.sections || !cart || typeof routes === "undefined" || !routes.cart_url) {
            doRender(data);
            return Promise.resolve();
        }
        var sectionIds = cart.getSectionsToRender().map(function (s) {
            return s.id;
        });
        return Promise.all(
            sectionIds.map(function (id) {
                return fetch(routes.cart_url + "?section_id=" + id, { cache: "no-store" }).then(function (r) {
                    return r.text();
                });
            })
        )
            .then(function (htmls) {
                var sections = {};
                sectionIds.forEach(function (id, i) {
                    sections[id] = htmls[i];
                });
                doRender(Object.assign({}, data, { sections: sections }));
            })
            .catch(function () {
                doRender(data);
            });
    }

    root.querySelectorAll(".js-feelawsm-funnel-atc").forEach(function (btn) {
        btn.addEventListener("click", function () {
            if (btn.getAttribute("aria-disabled") === "true") {
                return;
            }

            var cart = getCartUi();
            var vid = parseInt(btn.getAttribute("data-variant-id"), 10);
            var spRaw = btn.getAttribute("data-selling-plan") || "";
            var quantity = parseQuantity(btn);

            if (!vid || Number.isNaN(vid)) {
                alert("Missing variant");
                return;
            }

            var sellingPlanId = null;
            if (String(spRaw).trim() !== "") {
                var spNum = parseInt(spRaw, 10);
                if (!Number.isNaN(spNum)) {
                    sellingPlanId = spNum;
                }
            }

            var item = { id: vid, quantity: quantity };
            if (sellingPlanId != null) {
                item.selling_plan = sellingPlanId;
            }

            var body = { items: [item] };
            if (cart) {
                cart.setActiveElement(document.activeElement);
                if (sellingPlanId == null) {
                    body.sections = cart.getSectionsToRender().map(function (section) {
                        return section.id;
                    });
                    body.sections_url = window.location.pathname;
                }
            }

            var addUrl = getCartAddUrl();
            var bodyString = JSON.stringify(body);

            var previousHtml = btn.innerHTML;
            btn.innerHTML = "";
            btn.appendChild(document.createTextNode(addingLabel));
            btn.classList.add("feelawsm-funnel-atc--loading");
            btn.setAttribute("aria-busy", "true");
            btn.setAttribute("aria-disabled", "true");

            var cartAddPromise =
                sellingPlanId != null
                    ? new Promise(function (resolve, reject) {
                          var xhr = new XMLHttpRequest();
                          xhr.open("POST", addUrl, true);
                          xhr.setRequestHeader("Content-Type", "application/json");
                          xhr.setRequestHeader("Accept", "application/json");
                          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                          xhr.onload = function () {
                              if (xhr.status < 200 || xhr.status >= 400) {
                                  reject(new Error("Cart add failed: " + xhr.status));
                                  return;
                              }
                              try {
                                  resolve(JSON.parse(xhr.responseText));
                              } catch (e) {
                                  reject(e);
                              }
                          };
                          xhr.onerror = function () {
                              reject(new Error("Cart add network error"));
                          };
                          xhr.send(bodyString);
                      })
                    : fetch(addUrl, {
                          method: "POST",
                          headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                              "X-Requested-With": "XMLHttpRequest",
                          },
                          body: bodyString,
                      }).then(function (response) {
                          if (!response.ok) {
                              throw new Error("Cart add failed: " + response.status);
                          }
                          return response.json();
                      });

            cartAddPromise
                .then(function (response) {
                    if (response.status) {
                        if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                            publish(window.PUB_SUB_EVENTS.cartError, {
                                source: "feelawsm-electrolyte-funnel",
                                productVariantId: String(vid),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                        }
                        var desc = (response.description || response.message || "Could not add to cart").toString();
                        alert(desc);
                        return;
                    }

                    if (!cart) {
                        if (typeof routes !== "undefined" && routes.cart_url) {
                            window.location.href = routes.cart_url;
                        } else {
                            window.location.href = "/cart";
                        }
                        return;
                    }

                    if (typeof publish === "function" && window.PUB_SUB_EVENTS) {
                        publish(window.PUB_SUB_EVENTS.cartUpdate, {
                            source: "feelawsm-electrolyte-funnel",
                            productVariantId: String(vid),
                            cartData: response,
                        });
                    }
                    window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

                    var doRender = function (data) {
                        cart.renderContents(data);
                    };

                    if (cart.classList && cart.classList.contains("is-empty")) {
                        cart.classList.remove("is-empty");
                    }

                    return fetchSectionHtmlForCart(cart, response, doRender);
                })
                .catch(function (err) {
                    console.warn("[feelawsm-funnel]", err);
                    var msg = (err && err.message) || "Could not add to cart";
                    alert(msg);
                })
                .finally(function () {
                    btn.innerHTML = previousHtml;
                    btn.classList.remove("feelawsm-funnel-atc--loading");
                    btn.removeAttribute("aria-busy");
                    btn.removeAttribute("aria-disabled");
                });
        });
    });
})();
